export const FileReaderHandler = (event, setFileReaderContent) => {
  const file = event.target.files[0];
  if (file?.type?.includes("image")) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setFileReaderContent({
        fileName: file.name,
        fileContent: reader.result,
      });
    };
    reader.onerror = () => {
      console.log("file Error");
    };
  } else {
    swal("خطا", "لطفا تصویر انتخاب کنید", "error");
  }
};
